import LayoutApp from "@lhd/components/CloneApp/LayoutApp";
import { convertDataToDataForm } from "@lhd/components/CloneApp/untils";
import { AppRecordV2, AppSelectionList, AppV2 } from "@lhd/types";
import { Form } from "antd";
import { useMemo } from "react";
import { Styles } from "./styled";

export const DEFAULT_EXCLUDED_PDF_FIELD_NAMES = [
  "ステータス",
  "カテゴリー",
  "申請日",
  "承認日",
  "精算対象月",
];

interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
  excludeFieldNames?: string[];
}

const BusinessTripReportPDF = ({
  dataApp,
  appRecord,
  selectionDataList,
  excludeFieldNames = DEFAULT_EXCLUDED_PDF_FIELD_NAMES,
}: IProps) => {
  const [form] = Form.useForm();
  const appType = dataApp?.app_type;

  // Filter out excluded fields from PDF export
  const filteredDataApp = useMemo(() => {
    if (!dataApp?.app_parts) return dataApp;

    const targetExclude = excludeFieldNames || DEFAULT_EXCLUDED_PDF_FIELD_NAMES;

    return {
      ...dataApp,
      app_parts: dataApp.app_parts.filter((part) => {
        const plainLabel = (part.label_text || "")
          .replace(/<[^>]*>/g, "")
          .replace(/&nbsp;|&ensp;|&emsp;/g, " ")
          .trim();

        return !targetExclude.some((name) => {
          return (
            part.name === name ||
            part.name?.trim() === name ||
            part.label_text === name ||
            part.label === name ||
            part.field_code === name ||
            plainLabel === name ||
            (name === "精算対象月" &&
              (part.name === "精算対象月月" ||
                part.name?.trim() === "精算対象月月" ||
                plainLabel === "精算対象月月"))
          );
        });
      }),
    };
  }, [dataApp, excludeFieldNames]);

  if (appRecord) {
    const result = convertDataToDataForm(
      filteredDataApp?.app_parts || [],
      appRecord,
      true,
    );
    form.setFieldsValue(result);
  }

  return (
    <Styles>
      <table className="pdf-print-table">
        <thead>
          <tr>
            <td>
              <div className="pdf-print-header-space" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                style={{
                  transform: `scale(1)`,
                  transformOrigin: "top left",
                  width: `100%`,
                }}
              >
                <Form form={form} disabled>
                  <LayoutApp
                    form={form}
                    dataApp={filteredDataApp}
                    appRecord={appRecord}
                    appType={appType}
                    isEditPage={true}
                    isEditing={false}
                    isPDF={true}
                    selectionDataList={selectionDataList}
                  />
                </Form>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles>
  );
};

export default BusinessTripReportPDF;
